
  import ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 320,
    "md": 640,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xxl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
    }
  }
